import {
    useWindowDimensions,
    ScrollView,
    Image,
    View
} from "react-native";
import type SuperAdminPreviewModalProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitModal,
    NCoreUIKitTheme,
    Button,
    Text
} from "ncore-ui-kit";
import {
    UserCogIcon
} from "lucide-react-native";

const SuperAdminPreviewModal = ({
    modalId,
    orgName,
    admin
}: SuperAdminPreviewModalProps) => {
    const {
        radiuses,
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        width
    } = useWindowDimensions();
    const isMobile = width < 768;

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const InfoRow = ({
        label,
        value
    }: {
        label: string;
        value: string;
    }) => <View
        style={[
            stylesheet.infoRow,
            {
                gap: spaces.spacingSm
            }
        ]}
    >
        <Text
            style={stylesheet.unselectableText}
            variant="labelMediumSize"
            color="high"
        >
            {label}
        </Text>
        <Text
            variant="bodyMediumSize"
        >
            {value || "-"}
        </Text>
    </View>;

    return <View
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.content.container.default,
                width: isMobile ? "100%" : 500,
                borderRadius: radiuses.md,
                padding: spaces.spacingXl
            }
        ]}
    >
        <Text
            style={stylesheet.unselectableText}
            variant="titleMediumSize"
        >
            {localize("superadmin-preview-title")}
        </Text>
        <View
            style={[
                stylesheet.imageContainer,
                {
                    marginTop: spaces.spacingXl
                }
            ]}
        >
            {
                admin.profilePicturePath ?
                    <Image
                        style={[
                            stylesheet.profileImage,
                            {
                                borderRadius: radiuses.full
                            }
                        ]}
                        source={{
                            uri: admin.profilePicturePath
                        }}
                    />
                :
                    <View
                        style={[
                            stylesheet.profileImage,
                            {
                                backgroundColor: colors.content.container.mid,
                                borderRadius: radiuses.full,
                                justifyContent: "center",
                                alignItems: "center"
                            }
                        ]}
                    >
                        <UserCogIcon
                            color={colors.content.icon.high}
                            size={40}
                        />
                    </View>
            }
        </View>
        <ScrollView
            contentContainerStyle={[
                stylesheet.scrollContent,
                {
                    paddingBottom: spaces.spacingXl,
                    gap: spaces.spacingMd
                }
            ]}
            style={[
                stylesheet.scroll,
                {
                    marginBottom: spaces.spacingXl,
                    marginTop: spaces.spacingXl,
                    flexShrink: 1
                }
            ]}
            showsVerticalScrollIndicator={false}
        >
            <InfoRow
                value={new Date(admin.createdAt).toLocaleString("tr-TR")}
                label={localize("superadmin-preview-created-at")}
            />
            <InfoRow
                label={localize("superadmin-preview-admin-note")}
                value={admin.adminNote || "-"}
            />
            <InfoRow
                label={localize("superadmin-preview-fullname")}
                value={admin.fullName || "-"}
            />
            <InfoRow
                label={localize("superadmin-preview-username")}
                value={admin.username}
            />
            <InfoRow
                label={localize("superadmin-preview-about")}
                value={admin.about || "-"}
            />
            <InfoRow
                label={localize("superadmin-preview-phone")}
                value={admin.phone || "-"}
            />
            <InfoRow
                label={localize("superadmin-preview-address")}
                value={admin.address || "-"}
            />
            <InfoRow
                label={localize("superadmin-preview-org")}
                value={orgName}
            />
            <InfoRow
                label={localize("superadmin-preview-email")}
                value={admin.email}
            />
        </ScrollView>
        <Button
            title={localize("superadmin-preview-close")}
            onPress={() => NCoreUIKitModal.close({
                id: modalId
            })}
            spreadBehaviour="stretch"
            color="primary"
            type="neutral"
        />
    </View>;
};

export default SuperAdminPreviewModal;
